import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import About from "./pages/About.js";
import Products from "./pages/Products.js";
import Contact from "./pages/Contact.js";
import Home from "./pages/Home.js";
import Header from "./components/Header.js";
import Footer from "./components/Footer.js";

function App() {
  return (
    <Router>
      <header className="container-fluid">
        <Header />
      </header>
      <section className="section-main container-fluid">
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/products">
            <Products />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </section>
      <Footer />
    </Router>
  );
}

export default App;
